import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

const ConfirmDialog = ({ open, onClose, onConfirm=()=>{}, title="", content="",confirmOnly=false }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {confirmOnly? <Button onClick={onClose} color="info">
          確認
        </Button>:<><Button onClick={onClose} color="info">
          否
        </Button>
        <Button
          onClick={() => {
            onConfirm();
            onClose();
          }}
          color="info"
          autoFocus
        >
          是
        </Button></>}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
